import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  AddSectionApi,
  AddSectionsToQuoteApi,
  deleteSectionApi,
  EditSectionApi,
  getSectionListApi,
} from "helpers/ApiManager";
import { ApiResponse, PaginatedPayload } from "types/ApiResponse";
import {
  AddSectionArgs,
  AddSectionsToQuoteArgs,
  DeleteSectionArgs,
  EditSectionArgs,
  GetSectionListApiArgs,
  SectionPayloadData,
} from "types/section.api";
import { ErrorHandler, SuccessToast } from "utils/toast";

export const getSections = createAsyncThunk<
  ApiResponse<PaginatedPayload<SectionPayloadData>>, // return type
  GetSectionListApiArgs | undefined, // argument type
  { rejectValue: string } // rejected type
>("proposal-document/getSections", async (params, { rejectWithValue }) => {
  try {
    const response = await getSectionListApi(params);
    console.log(response);
    return response;
  } catch (err: any) {
    console.log(err);
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});

export const deleteSection = createAsyncThunk<
  ApiResponse<number>, // return type
  DeleteSectionArgs,
  { rejectValue: string } // rejected type
>("proposal-document/deleteSection", async (params, { rejectWithValue }) => {
  try {
    const response = await deleteSectionApi(params);
    response.payload = params.sectionId;
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to delete");
  }
});

export const addSection = createAsyncThunk<
  ApiResponse<SectionPayloadData>, // return type
  AddSectionArgs, // argument type
  { rejectValue: string } // rejected type
>("proposal-document/addSection", async (params, { rejectWithValue }) => {
  try {
    const response = await AddSectionApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to add");
  }
});

export const editSection = createAsyncThunk<
  ApiResponse<SectionPayloadData>, // return type
  EditSectionArgs, // argument type
  { rejectValue: string } // rejected type
>("proposal-document/editSection", async (params, { rejectWithValue }) => {
  try {
    const response = await EditSectionApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to edit");
  }
});

export const addSectionsToQuote = createAsyncThunk<
  ApiResponse<null>, // return type
  AddSectionsToQuoteArgs, // argument type
  { rejectValue: string } // rejected type
>(
  "proposal-document/addSectionsToQuote",
  async (params, { rejectWithValue }) => {
    try {
      const response = await AddSectionsToQuoteApi(params);
      SuccessToast(response.message);
      return response;
    } catch (err: any) {
      ErrorHandler(err);
      return rejectWithValue(err?.message || "Failed to add sections to quote");
    }
  }
);
